/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ListParams, PageResultAiResponse } from '@squiz/dxp-ai-client';
import { UseObservableResult, useDeepCompareMemo, useObservable } from '@squiz/dxp-console-support';
import { Observable, from } from 'rxjs';
import { getAiService } from '../GetAiService/getAiService';

/**
 * React hook to get chatbot Ai paginated list
 */
export function usePaginatedChatbotList(query: ListParams): UseObservableResult<PageResultAiResponse | null> {
  const aiService = getAiService();

  const page$ = useDeepCompareMemo((): Observable<PageResultAiResponse> => {
    return from(aiService.apiClient.chatbot.list(query));
  }, [aiService, query]);

  return useObservable(page$, [query, aiService]);
}
